import React, { useEffect, useState } from "react";
import { Card, Table, Spinner, Badge } from "react-bootstrap";
import { fetchTalentPaymentsApi } from "../../../services/api";
import './TalentBillingPage.css';

const TalentBillingPage = () => {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { loadPayments(); }, []);

    const loadPayments = async () => {
        try {
            const response = await fetchTalentPaymentsApi();
            setPayments(response.data.data || []);
        } catch (error) { console.error(error); } 
        finally { setLoading(false); }
    };

    return (
        <div className="container-fluid py-4">
            <Card className="shadow-lg border-0 talent-billing-card" style={{ background: "#111827", borderRadius: "18px" }}>
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h3 className="text-white fw-bold mb-1 talent-billing-title">Billing History</h3>
                            <p className="text-light mb-0 small talent-billing-subtitle">View all your audition payments</p>
                        </div>
                    </div>
                    {loading ? (
                        <div className="text-center py-5"><Spinner animation="border" variant="danger" /></div>
                    ) : (
                        <div className="table-responsive">
                            <Table hover borderless className="align-middle text-white talent-billing-table">
                                <thead>
                                    <tr style={{ background: "#1f2937" }}>
                                        <th>User Name</th>
                                        <th>Role Name</th>
                                        
                                        <th>Payment ID</th>
                                        <th>Status</th>
                                        <th>Payment Mode</th>
                                        <th>Amount</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {payments.length > 0 ? payments.map((item, index) => (
                                        <tr key={index} style={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
                                            {/* <td>{item.userName}</td>
                                            <td className="fw-bold">{item.roleName}</td> */}

                                    <td className="billing-user-name">
                                    {item.userName}
                                    </td>

                                    <td className="billing-role-name">
                                    {item.roleName}
                                    </td>
                                            <td>{item.paymentId}</td>
                                            <td>
                                                <Badge bg={item.paymentStatus === "SUCCESS" ? "success" : "warning"}>
                                                    {item.paymentStatus}
                                                </Badge>
                                            </td>
                                            <td><Badge bg="info">{item.paymentMode}</Badge></td>
                                            <td className="fw-bold text-success">₹{item.amount}</td>
                                            <td>{new Date(item.date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="8" className="text-center py-5 text-light">No payment history found</td></tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};
export default TalentBillingPage;